<section class="how-it-works">
  <h2 class="how-it-works__title">{{ "UX_TEXT.HOW_IT_WORKS.TITLE" | translate }}</h2>

  <div class="how-it-works__scroll">
    <article class="how-it-works__card" *ngFor="let step of steps; let i = index">
      <span
        class="how-it-works__num"
        [ngStyle]="{
          background: step.color,
          color: step.darkText ? '#0f172a' : '#ffffff'
        }"
      >
        {{ step.number }}
      </span>
      <h3 class="how-it-works__card-title">{{ step.titleKey | translate }}</h3>
      <p class="how-it-works__desc">{{ step.descriptionKey | translate }}</p>
      <ion-icon
        *ngIf="i < steps.length - 1"
        class="how-it-works__arrow"
        name="chevron-forward-outline"
      ></ion-icon>
    </article>
  </div>
</section>
